export enum ChatMessageTypes {
  Unknown = 0,
  NewUser = 1,
  Welcome = 2,
  NewChat = 3,
  Chat = 4,
  Commentary = 5,
  Devotional = 6,
  UserProfileSummary = 7,
}
